/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabTestMaterialApi } from '../api/labtestmaterial.api';
import { switchMap, map } from 'rxjs/operators';
import { LabTestMaterialData, LabTestMaterial } from '../../../interfaces/masters/labtestmaterial';

@Injectable()
export class LabTestMaterialService extends LabTestMaterialData {

  constructor(private api: LabTestMaterialApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<LabTestMaterial[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<LabTestMaterial>{
      return this.api.getById(url);
  }

  create(url: string, data:LabTestMaterial): Observable<LabTestMaterial> {
    return this.api.add(url,data);
  }

  update(url: string, data:LabTestMaterial): Observable<LabTestMaterial> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
